<section class="chip" [attr.colorScheme]="colorScheme()">
  <span>{{ label() }}</span>
</section>
